module.exports = __webpack_public_path__ + "media/components/brandings/svgs/email/branding-email-content-79189945a94bd8f9a3ab2cc4790baf8c.svg";